export interface CellSatisfaction {
  sound: number;  // 0-1
  light: number;  // 0-1
  drinks: number; // 0-1
  space: number;  // 0-1
}

const WEIGHT_SOUND = 0.40;
const WEIGHT_LIGHT = 0.25;
const WEIGHT_DRINKS = 0.20;
const WEIGHT_SPACE = 0.15;

/**
 * Calculates satisfaction as a weighted average of coverage factors.
 */
export class SatisfactionCalculator {
  static calculate(input: CellSatisfaction): number {
    return (
      input.sound * WEIGHT_SOUND +
      input.light * WEIGHT_LIGHT +
      input.drinks * WEIGHT_DRINKS +
      input.space * WEIGHT_SPACE
    );
  }

  static venueAverage(cells: CellSatisfaction[]): number {
    if (cells.length === 0) return 0;
    const total = cells.reduce((sum, cell) => sum + this.calculate(cell), 0);
    return total / cells.length;
  }
}
